import { render, staticRenderFns } from "./ShadowGroupNameModal.vue?vue&type=template&id=a0788484&scoped=true"
import script from "./ShadowGroupNameModal.vue?vue&type=script&lang=js"
export * from "./ShadowGroupNameModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0788484",
  null
  
)

export default component.exports